module.exports = __webpack_public_path__ + "img/mh.1f5cce0a.jpg";